// DNS provider view model and fixed onboarding copy. Provider details come from
// the backend's domain check; field labels follow each provider's own UI.

export const RECORD_NAME = 'traceira-authz';

/** Automatic record checks repeat every 8 s on Step 2. */
export const CHECK_INTERVAL_MS = 8000;

export type ProviderKind = 'cloudflare' | 'other' | 'unknown' | 'missing';

export interface Provider {
  kind: ProviderKind;
  /** Display name, e.g. "Cloudflare" or "Route 53 (Amazon)". Empty when not recognized. */
  name: string;
  /** Short name used in buttons and instructions, e.g. "Cloudflare". */
  shortName: string;
  nameservers: readonly string[];
  /** Instruction line before the record fields; DNS → Records → Add record style. */
  path: readonly string[] | null;
  hasProxy: boolean;
  /** The provider's DNS dashboard, opened in a new tab. */
  dashboardUrl: string | null;
}

/** The provider's DNS page; for Cloudflare, straight to this zone's DNS records. */
export function dashboardUrlFor(name: string, zone: string): string | null {
  if (name === 'Cloudflare')
    return `https://dash.cloudflare.com/?to=/:account/${encodeURIComponent(zone)}/dns/records`;
  if (name.startsWith('Route 53')) return 'https://console.aws.amazon.com/route53/v2/hostedzones';
  return null;
}

export const MEANING = [
  'Traceira can publish authorizations for {domain} through your record. Nothing is tested until you review and sign the exact authorization.',
  'Subdomains are included only when the authorization names them.',
  'Keep the record in place. Deleting it withdraws authorization.',
] as const;
